<template>
  <div>
    <two-panel
      :left-panel-width="'820'"
      :right-panel-width="'567'"
      :left-panel-title="leftPanelTitle"
      :right-panel-title="rightPanelTitle"
    >
      <template #leftPanel>
        <table-list-component
          ref="tableListComponent"
          :table-height="'603'"
          :headers="headers"
          :nowPerPage="nowPerPage"
          :items="phrCodes"
          :totalRecords="totalRecords"
          :totalPages="totalPages"
          :customSlotInfo="customSlotInfo"
          :searchOpts="searchPhrCode"
          :loading="isTableOverlay"
          :reloadToggle="reloadToggle"
          @rowClick="rowClick"
          @getDataFromApi="getDataFromApi"
        >
          <template #searchOptions>
            <label for="search_codeSysTyCode" class="sort-label">
              · 용어체계
            </label>
            <select
              id="search_codeSysTyCode"
              class="sort-input-text"
              v-model="searchPhrCode.codeSysTyCode"
            >
              <option
                v-for="(item, index) in phrCodeSysTys"
                :key="index"
                :value="item.codeId"
                >{{ item.codeName }}</option
              >
            </select>
            <label for="search_resrceTyCode" class="sort-label">
              · 리소스 유형
            </label>
            <select
              id="search_resrceTyCode"
              class="sort-input-text"
              v-model="searchPhrCode.resrceTyCode"
            >
              <option
                v-for="(item, index) in fhirResrceTys"
                :key="index"
                :value="item.codeId"
              >
                {{ item.codeName }}
              </option>
            </select>
            <br />
            <label for="search_mesureKey" class="sort-label">
              · Mesure Key
            </label>
            <input
              type="text"
              id="search_mesureKey"
              class="sort-input-text"
              v-model="searchPhrCode.mesureKey"
              maxlength="20"
              @keydown.enter="doSearch()"
            />
            <label for="search_mesureCodeNm" class="sort-label">
              · 코드 이름
            </label>
            <input
              type="text"
              id="search_mesureCodeNm"
              class="sort-input-text"
              v-model="searchPhrCode.mesureCodeNm"
              maxlength="20"
              @keydown.enter="doSearch()"
            />
            <label for="search_mesureCode" class="sort-label">
              · 코드 값
            </label>
            <input
              type="text"
              id="search_mesureCode"
              class="sort-input-text"
              v-model="searchPhrCode.mesureCode"
              maxlength="20"
              @keydown.enter="doSearch()"
            />
          </template>
          <template #subHeaderItem>
            <input
              type="button"
              class="bt-line24 cr-orange"
              :value="'등록'"
              @click="doOpenInsertPopUp(true)"
            />
          </template>
          <template v-slot:codeSysUri_custom="{ item }">
            <td
              class="text-center td-ellipsis"
              :title="doGetCodeSysNm(item.codeSysUri)"
            >
              {{ doGetCodeSysNm(item.codeSysUri) }}
            </td>
          </template>
          <template v-slot:resrceTyCode_custom="{ item }">
            <td
              class="text-center td-ellipsis"
              :title="doGetResourceTypeCodeNm(item.resrceTyCode)"
            >
              {{ doGetResourceTypeCodeNm(item.resrceTyCode) }}
            </td>
          </template>
          <template v-slot:mesureKey_custom="{ item }">
            <td class="text-center td-ellipsis" :title="item.mesureKey">
              {{ item.mesureKey }}
            </td>
          </template>
          <template v-slot:mesureCodeNm_custom="{ item }">
            <td class="text-center td-ellipsis" :title="item.mesureCodeNm">
              {{ item.mesureCodeNm }}
            </td>
          </template>
          <template v-slot:mesureCode_custom="{ item }">
            <td class="text-center td-ellipsis" :title="item.mesureCode">
              {{ item.mesureCode }}
            </td>
          </template>
          <template v-slot:crtrId_custom="{ item }">
            <td class="text-center td-ellipsis" :title="item.crtrId">
              {{ item.crtrId }}
            </td>
          </template>
          <template v-slot:creatDt_custom="{ item }">
            <td
              class="text-center td-ellipsis"
              :title="getFormatDate(item.creatDt)"
            >
              {{ getFormatDate(item.creatDt) }}
            </td>
          </template>
        </table-list-component>
      </template>
      <template #rightPanel>
        <table-tab-component
          :table-height="'746'"
          :tab-overlay="isTabOverlay"
          :tab-items="tabItems"
        >
          <template #codeSysUri_tab_custom="{item}">
            <td>
              {{ doGetCodeSysNm(item.value) }}
            </td>
          </template>
          <template #children_tab_custom="{item}">
            <td class="phr_code_children_tab" style="padding: 0px !important;">
              <div style="height: 158px">
                <table class="table-style-default">
                  <colgroup>
                    <col width="37%" />
                    <col width="26%" />
                    <col width="37%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Mesure Key</th>
                      <th>코드 이름</th>
                      <th>코드 값</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(child, index) in item.value" :key="index">
                      <td>
                        {{ child.mesureKey }}
                      </td>
                      <td>
                        {{ child.mesureCodeNm }}
                      </td>
                      <td>
                        {{ child.mesureCode }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </template>

          <template #phrCodeInfo_bottom_button>
            <div class="table-bot-btns">
              <p class="f-right">
                <input
                  v-show="showTemplateBtn"
                  type="button"
                  value="Template"
                  class="bt-line24 cr-orange"
                  @click="doOpenTemplatePopUp()"
                />
                <input
                  type="button"
                  :value="btnUpdate"
                  class="bt-line24 cr-gray"
                  @click="doOpenUpdatePopUp()"
                />
                <input
                  type="button"
                  :value="btnDelete"
                  class="bt-line24 cr-gray"
                  @click="doDeletePhrCode()"
                />
              </p>
            </div>
          </template>
        </table-tab-component>
      </template>
    </two-panel>

    <phr-code-insert-pop-up
      ref="phrCodeInsertPopUp"
      :is-open="isOpenInsertPopUp"
      @close="doCloseInsertPopUp"
      :phr-code-sys-tys="phrCodeSysTysExceptAll"
      :fhir-resrce-tys="fhirResrceTysExceptAll"
      :insert-phr-code-info="insertPhrCodeInfo"
      @addRow="doAddRowInsertPhrCodeChildren"
      @deleteRow="doDeleteRowInsertPhrCodeChildren"
      @getIsExistMesureKey="doGetIsExistInsertMesureKey"
      @insertPhrCode="doInsertPhrCode"
      @inputMesureKey="doInputMesureKeyInsertPhrCodeInfo"
      @changeCodeSysTyCode="doChangeCodeSysTyCodeInsertPhrCodeInfo"
    ></phr-code-insert-pop-up>

    <phr-code-update-pop-up
      ref="phrCodeUpdatePopUp"
      :is-open="isOpenUpdatePopUp"
      @close="doCloseUpdatePopUp"
      :phr-code-sys-tys="phrCodeSysTysExceptAll"
      :fhir-resrce-tys="fhirResrceTysExceptAll"
      :update-phr-code-info="updatePhrCodeInfo"
      @addRow="doAddRowUpdatePhrCodeChildren"
      @deleteRow="doDeleteRowUpdatePhrCodeChildren"
      @getIsExistChildrenMesureKey="doGetIsExistUpdatePhrCodeInfo"
      @inputMesureKey="doInputMesureKeyUpdatePhrCodeInfo"
      @changeCodeSysTyCode="doChangeCodeSysTyCodeUpdatePhrCodeInfo"
      @updatePhrCode="doUpdatePhrCode"
    ></phr-code-update-pop-up>

    <phr-code-template-popup
      ref="phrCodeTemplatePopUp"
      :is-open="isOpenTemplatePopup"
      :templateInfo="templateInfo"
      @close="doCloseTemplatePopup"
    />
  </div>
</template>

<script>
import TwoPanel from '@/layouts/TwoPanel.vue';
import TableListComponent from '@/components/TableListComponent.vue';
import TableTabComponent from '@/components/TableTabComponent.vue';
import {
  getPhrCodes,
  deletePhrCode,
  getIsExistMesureKey,
  insertPhrCode,
  updatePhrCode,
  getPhrCodeTemplate,
} from '@/api/phrApi';
import CommonMixins from '@/mixins/CommonMixins';
import PhrCodeInsertPopUp from '@/views/phr/code/PhrCodeInsertPopUp.vue';
import PhrCodeUpdatePopUp from '@/views/phr/code/PhrCodeUpdatePopUp.vue';
import PhrCodeTemplatePopup from '@/views/phr/code/PhrCodeTemplatePopup.vue';

export default {
  data() {
    return {
      nowPerPage: 30,
      totalPages: 0,
      totalRecords: 0,
      reloadToggle: false,
      phrCodes: [],
      searchPhrCode: {
        codeSysTyCode: '',
        resrceTyCode: '',
        mesureKey: '',
        mesureCodeNm: '',
        mesureCode: '',
      },
      isTableOverlay: false,
      customSlotInfo: [
        {
          name: 'codeSysUri',
          slotName: 'item.codeSysUri',
        },
        {
          name: 'resrceTyCode',
          slotName: 'item.resrceTyCode',
        },
        {
          name: 'mesureKey',
          slotName: 'item.mesureKey',
        },
        {
          name: 'mesureCodeNm',
          slotName: 'item.mesureCodeNm',
        },
        {
          name: 'mesureCode',
          slotName: 'item.mesureCode',
        },
        {
          name: 'crtrId',
          slotName: 'item.crtrId',
        },
        {
          name: 'creatDt',
          slotName: 'item.creatDt',
        },
      ],
      clickedRow: {},
      isTabOverlay: false,
      tabItems: [],
      isOpenInsertPopUp: false,
      phrCodeSysTysExceptAll: [],
      fhirResrceTysExceptAll: [],
      insertPhrCodeInfo: this.initInsertPhrCodeInfo(),
      isOpenUpdatePopUp: false,
      updatePhrCodeInfo: this.initUpdatePhrCodeInfo(),
      isOpenTemplatePopup: false,
      templateInfo: {
        fhirTemplate: null,
        simplePhrRequest: null,
      },
    };
  },
  mixins: [CommonMixins],
  components: {
    TwoPanel,
    TableListComponent,
    TableTabComponent,
    PhrCodeInsertPopUp,
    PhrCodeUpdatePopUp,
    PhrCodeTemplatePopup,
  },
  methods: {
    async doGetPhrCodes(searchParams) {
      try {
        const {
          page,
          rows,
          sidx,
          sord,
          mesureKey,
          mesureCode,
          mesureCodeNm,
          resrceTyCode,
          codeSysTyCode,
        } = searchParams;

        const reqObj = {
          page,
          rows,
          sidx,
          sord,
          mesureCodeNm: mesureCodeNm.trim(),
          mesureKey: mesureKey.trim(),
          mesureCode: mesureCode.trim(),
          codeSysTyCode,
          resrceTyCode,
        };
        const { data } = await getPhrCodes(reqObj);
        const { rows: items, totalPages, totalRecords } = data;
        this.phrCodes = items;
        this.totalPages = totalPages;
        this.totalRecords = totalRecords;
      } catch (error) {
        console.log('error', error);
      }
    },
    async doGetPhrCodeDetail() {
      this.isTabOverlay = true;
      let phrCodeInfoTabItems = this.tabItems[0].selectedItem;

      const {
        codeSysUri,
        mesureKey,
        mesureCodeNm,
        mesureCodeDc,
        resrceTyCode,
        mesureCode,
        children,
        crtrId,
        creatDt,
        updusrId,
        updtDt,
      } = this.clickedRow;

      phrCodeInfoTabItems.codeSysUri.value = codeSysUri;
      phrCodeInfoTabItems.mesureKey.value = mesureKey;
      phrCodeInfoTabItems.mesureCodeNm.value = mesureCodeNm;
      phrCodeInfoTabItems.mesureCodeDc.value = mesureCodeDc;
      phrCodeInfoTabItems.resourceTypeCodeNm.value = this.doGetResourceTypeCodeNm(
        resrceTyCode,
      );
      phrCodeInfoTabItems.mesureCode.value = mesureCode;
      phrCodeInfoTabItems.children.value = children;
      phrCodeInfoTabItems.crtrId.value = crtrId;
      phrCodeInfoTabItems.creatDt.value =
        creatDt !== '-' ? this.getFormatDate(creatDt) : '-';
      phrCodeInfoTabItems.updusrId.value = updusrId;
      phrCodeInfoTabItems.updtDt.value =
        updtDt !== '-' ? this.getFormatDate(updtDt) : '-';

      this.isTabOverlay = false;
    },
    rowClick(item) {
      this.clickedRow = item;
      this.doGetPhrCodeDetail();
    },
    async getDataFromApi(searchParams) {
      this.isTableOverlay = true;
      this.doResetClicked();
      await this.doGetPhrCodes(searchParams);
      this.isTableOverlay = false;
    },
    doGetResourceTypeCodeNm(resrceTyCode) {
      let resourceTypeCodeNm;

      if (this.fhirResrceTys.length > 0) {
        for (let i in this.fhirResrceTys) {
          const phrCodeSysTy = this.fhirResrceTys[i];
          const { codeId, codeName } = phrCodeSysTy;
          if (resrceTyCode === codeId) {
            resourceTypeCodeNm = codeName;
            break;
          }
        }
      } else {
        resourceTypeCodeNm = resrceTyCode;
      }

      return resourceTypeCodeNm;
    },
    doGetCodeSysNm(codeSysUri) {
      let codeSysNm = '-';
      if (codeSysUri && this.phrCodeSysTys.length > 0) {
        for (let i in this.phrCodeSysTys) {
          const { codeName, description } = this.phrCodeSysTys[i];
          if (description.includes(codeSysUri)) {
            codeSysNm = codeName;
            break;
          }
        }
      }
      return codeSysNm;
    },
    doGetCodeSysTyCode(codeSysUri) {
      let codeSysTyCode;

      if (codeSysUri && this.phrCodeSysTys.length > 0) {
        for (let i in this.phrCodeSysTys) {
          const { codeId, description } = this.phrCodeSysTys[i];
          if (description.includes(codeSysUri)) {
            codeSysTyCode = codeId;
            break;
          }
        }
      }

      return codeSysTyCode;
    },
    doSearch() {
      this.$refs.tableListComponent.search();
    },
    doResetClicked() {
      this.doResetTab();
      this.clickedRow = {};
    },
    doResetTab() {
      let phrCodeInfoTabItems = this.tabItems[0].selectedItem;
      const keys = Object.keys(phrCodeInfoTabItems);
      keys.forEach(key => {
        const item = phrCodeInfoTabItems[key];
        if (key == 'children') {
          item.value = [];
        } else {
          item.value = '';
        }
      });
    },
    initCommonCode(phrCodeSysTys, fhirResrceTys) {
      if (phrCodeSysTys.length > 0) {
        phrCodeSysTys.forEach((phrCodeSysTy, index) => {
          if (index === 0) {
            this.searchPhrCode.codeSysTyCode = phrCodeSysTy.codeId;
          } else {
            this.phrCodeSysTysExceptAll.push(phrCodeSysTy);
          }
        });
      }

      if (fhirResrceTys.length > 0) {
        fhirResrceTys.forEach((fhirResrceTy, index) => {
          if (index === 0) {
            this.searchPhrCode.resrceTyCode = fhirResrceTy.codeId;
          } else {
            this.fhirResrceTysExceptAll.push(fhirResrceTy);
          }
        });
      }
    },
    async doDeletePhrCode() {
      if (this.isEmptyObject(this.clickedRow)) {
        this.$dialogs.alert('PHR 코드를 선택해주세요.');
        return false;
      }

      const { mesureCodeSn, codeSysUri, mesureKey } = this.clickedRow;
      const codeSysNm = this.doGetCodeSysNm(codeSysUri);

      const confirmMessage = `<p>용어체계 : <span class="c-orange">${codeSysNm}</span><p>Mesure Key : <span class="c-orange">${mesureKey}</span></p>${this.$i18n.t(
        'common.alert.delete-confirm',
      )}`;

      const { ok } = await this.$dialogs.confirm(confirmMessage);
      if (ok) {
        try {
          this.isTabOverlay = true;
          const { data } = await deletePhrCode(mesureCodeSn);
          const { message, valid } = data;
          if (valid) {
            await this.$dialogs.alert(message);
            this.reloadToggle = !this.reloadToggle;
          }
        } catch (error) {
          console.log('error', error);
        } finally {
          this.isTabOverlay = false;
        }
      }
    },
    initInsertPhrCodeInfo() {
      return {
        mesureKey: '',
        isPassedMesureKey: false,
        mesureCodeNm: '',
        mesureCodeDc: '',
        resrceTyCode: '',
        mesureCode: '',
        codeSysTyCode: '',
        children: [
          {
            mesureKey: '',
            mesureCodeNm: '',
            mesureCodeDc: '',
            mesureCode: '',
            isPassedMesureKey: false,
          },
        ],
      };
    },
    doOpenInsertPopUp(isOpen) {
      this.$refs.phrCodeInsertPopUp.doReset();
      this.isOpenInsertPopUp = isOpen;
    },
    doCloseInsertPopUp(isClose) {
      this.$refs.phrCodeInsertPopUp.doReset();
      this.isOpenInsertPopUp = isClose;
      this.insertPhrCodeInfo = this.initInsertPhrCodeInfo();
    },
    doAddRowInsertPhrCodeChildren() {
      this.insertPhrCodeInfo.children.push({
        mesureKey: '',
        mesureCodeNm: '',
        mesureCodeDc: '',
        mesureCode: '',
        isPassedMesureKey: false,
      });
    },
    doDeleteRowInsertPhrCodeChildren(index) {
      this.insertPhrCodeInfo.children.splice(index, 1);
    },
    async doGetIsExistInsertMesureKey(mode, index, reqObj) {
      try {
        const { data } = await getIsExistMesureKey(reqObj);
        const { valid, message } = data;
        if (mode === 'parents') {
          this.insertPhrCodeInfo.isPassedMesureKey = valid;
        } else if (mode === 'child') {
          this.insertPhrCodeInfo.children[index].isPassedMesureKey = valid;
        }
        this.$dialogs.alert(message);
      } catch (error) {
        console.log('error', error);
      }
    },
    async doInsertPhrCode(isHasChildren) {
      const {
        mesureKey,
        mesureCodeNm,
        mesureCodeDc,
        resrceTyCode,
        mesureCode,
        codeSysTyCode,
        children,
      } = this.insertPhrCodeInfo;

      const reqObj = {
        mesureKey: mesureKey.trim(),
        mesureCodeNm: mesureCodeNm.trim(),
        mesureCodeDc: mesureCodeDc.trim(),
        resrceTyCode,
        mesureCode: mesureCode.trim(),
        codeSysTyCode,
      };

      if (isHasChildren) {
        children.forEach(child => {
          child.mesureKey.trim();
          child.mesureCodeNm.trim();
          child.mesureCodeDc.trim();
          child.mesureCode.trim();
        });

        reqObj['children'] = children;
      }

      try {
        const { data } = await insertPhrCode(reqObj);
        const { valid, message } = data;
        const { ok } = await this.$dialogs.alert(message);
        if (ok) {
          if (valid) {
            this.doCloseInsertPopUp();
            this.reloadToggle = !this.reloadToggle;
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    doInputMesureKeyInsertPhrCodeInfo(mode, index) {
      if (mode === 'parents') {
        this.insertPhrCodeInfo.isPassedMesureKey = false;
      } else if (mode === 'child') {
        this.insertPhrCodeInfo.children[index].isPassedMesureKey = false;
      }
    },
    doChangeCodeSysTyCodeInsertPhrCodeInfo() {
      this.insertPhrCodeInfo.isPassedMesureKey = false;
      if (this.insertPhrCodeInfo.children.length > 0) {
        this.insertPhrCodeInfo.children.forEach(child => {
          child.isPassedMesureKey = false;
        });
      }
    },
    initUpdatePhrCodeInfo() {
      return {
        mesureCodeSn: 0,
        mesureKey: '',
        mesureCodeNm: '',
        mesureCodeDc: '',
        resrceTyCode: '',
        mesureCode: '',
        codeSysTyCode: '',
        isPassedMesureKey: false,
        isAlreadyPassed: false,
        children: [],
      };
    },
    doSetUpdatePhrCodeInfo(clickedRowInfo) {
      const {
        mesureCodeSn,
        mesureKey,
        mesureCodeNm,
        mesureCodeDc,
        resrceTyCode,
        mesureCode,
        codeSysUri,
        children,
      } = clickedRowInfo;

      this.updatePhrCodeInfo.mesureCodeSn = mesureCodeSn;
      this.updatePhrCodeInfo.mesureKey = mesureKey;
      this.updatePhrCodeInfo.mesureCodeNm = mesureCodeNm;
      this.updatePhrCodeInfo.mesureCodeDc = mesureCodeDc;
      this.updatePhrCodeInfo.resrceTyCode = resrceTyCode;
      this.updatePhrCodeInfo.mesureCode = mesureCode;
      this.updatePhrCodeInfo.codeSysTyCode = this.doGetCodeSysTyCode(
        codeSysUri,
      );
      this.updatePhrCodeInfo.isPassedMesureKey = true;
      this.updatePhrCodeInfo.isAlreadyPassed = true;

      if (children.length > 0) {
        children.forEach(child => {
          this.updatePhrCodeInfo.children.push({
            mesureKey: child.mesureKey,
            mesureCodeNm: child.mesureCodeNm,
            mesureCodeDc: child.mesureCodeDc,
            mesureCode: child.mesureCode,
            isAlreadyPassed: true,
            isPassedMesureKey: true,
          });
        });
      } else {
        this.updatePhrCodeInfo.children.push({
          mesureKey: '',
          mesureCodeNm: '',
          mesureCodeDc: '',
          mesureCode: '',
          isAlreadyPassed: false,
          isPassedMesureKey: false,
        });
      }
    },
    doOpenUpdatePopUp() {
      if (this.isEmptyObject(this.clickedRow)) {
        this.$dialogs.alert('PHR 코드를 선택해주세요.');
        return false;
      }

      this.doSetUpdatePhrCodeInfo(this.clickedRow);

      this.isOpenUpdatePopUp = true;
    },
    doCloseUpdatePopUp() {
      this.isOpenUpdatePopUp = false;
      this.$refs.phrCodeUpdatePopUp.doReset();
      this.updatePhrCodeInfo = this.initUpdatePhrCodeInfo();
    },
    doAddRowUpdatePhrCodeChildren() {
      this.updatePhrCodeInfo.children.push({
        mesureKey: '',
        mesureCodeNm: '',
        mesureCodeDc: '',
        mesureCode: '',
        isAlreadyPassed: false,
        isPassedMesureKey: false,
      });
    },
    doDeleteRowUpdatePhrCodeChildren(index) {
      this.updatePhrCodeInfo.children.splice(index, 1);
    },
    async doGetIsExistUpdatePhrCodeInfo(index, reqObj) {
      try {
        const { data } = await getIsExistMesureKey(reqObj);
        const { valid, message } = data;
        this.updatePhrCodeInfo.children[index].isPassedMesureKey = valid;
        this.$dialogs.alert(message);
      } catch (error) {
        console.log('error', error);
      }
    },
    doInputMesureKeyUpdatePhrCodeInfo(mode, index) {
      if (mode === 'parents') {
        this.updatePhrCodeInfo.isPassedMesureKey = false;
      } else if (mode === 'child') {
        this.updatePhrCodeInfo.children[index].isPassedMesureKey = false;
      }
    },
    doChangeCodeSysTyCodeUpdatePhrCodeInfo() {
      this.updatePhrCodeInfo.isPassedMesureKey = false;
      if (this.updatePhrCodeInfo.children.length > 0) {
        this.updatePhrCodeInfo.children.forEach(child => {
          child.isPassedMesureKey = false;
        });
      }
    },
    async doUpdatePhrCode(isHasChildren) {
      const {
        mesureCodeSn,
        mesureKey,
        mesureCodeNm,
        mesureCodeDc,
        resrceTyCode,
        mesureCode,
        codeSysTyCode,
        children,
      } = this.updatePhrCodeInfo;

      let reqObj = {
        mesureCodeSn,
        mesureKey,
        mesureCodeNm,
        mesureCodeDc,
        resrceTyCode,
        mesureCode,
        codeSysTyCode,
      };

      if (isHasChildren) {
        reqObj['children'] = children;
      }

      try {
        const { data } = await updatePhrCode(reqObj);
        const { valid, message } = data;
        const { ok } = await this.$dialogs.alert(message);
        if (ok) {
          if (valid) {
            this.doCloseUpdatePopUp();
            this.reloadToggle = !this.reloadToggle;
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    // 템플릿 관련
    async doOpenTemplatePopUp() {
      if (this.isEmptyObject(this.clickedRow)) {
        this.$dialogs.alert('PHR 코드를 선택해주세요.');
        return false;
      }

      const { resrceTyCode, mesureKey } = this.clickedRow;
      const resrceTyName = this.doGetResourceTypeCodeNm(resrceTyCode);

      if (resrceTyName == 'Extension' || resrceTyName == 'DiagnosicReport') {
        this.$dialogs.alert('템플릿을 제공하지 않는 리소스 유형입니다.');
        return false;
      }

      try {
        const { data } = await getPhrCodeTemplate({
          resourceType: resrceTyName,
          measureKey: mesureKey,
        });
        this.templateInfo.fhirTemplate = data.fhirTemplate;
        this.templateInfo.simplePhrRequest = data.simplePhrRequest;
      } catch (error) {
        console.log('error', error);
      }

      if (
        this.templateInfo.fhirTemplate === null &&
        this.templateInfo.simplePhrRequest === null
      ) {
        this.$dialogs.alert('템플릿이 존재하지 않습니다.');
        return false;
      }

      this.isOpenTemplatePopup = true;
    },
    doCloseTemplatePopup() {
      this.isOpenTemplatePopup = false;
      this.templateInfo.simplePhrRequest = null;
      this.templateInfo.fhirTemplate = null;
    },
  },
  computed: {
    leftPanelTitle() {
      return 'PHR 코드 목록';
    },
    rightPanelTitle() {
      return 'PHR 코드 상세';
    },
    headers() {
      return [
        {
          text: '용어체계',
          value: 'codeSysUri',
          width: '15%',
          sortable: true,
        },
        {
          text: '리소스 유형',
          value: 'resrceTyCode',
          width: '13%',
          sortable: false,
        },
        {
          text: 'Measure Key',
          value: 'mesureKey',
          width: '20%',
          sortable: true,
        },
        {
          text: '코드이름',
          value: 'mesureCodeNm',
          width: '20%',
          sortable: true,
        },
        {
          text: '코드 값',
          value: 'mesureCode',
          width: '17%',
          sortable: false,
        },
        {
          text: '등록일자',
          value: 'creatDt',
          width: '15%',
          sortable: true,
        },
      ];
    },
    phrCodeSysTys() {
      return this.$store.state.common.phrCodeSysTys;
    },
    fhirResrceTys() {
      return this.$store.state.common.fhirResrceTys;
    },
    tabItemsComputed() {
      return [
        {
          id: 'phrCodeInfo',
          headers: [
            {
              text: '항목',
              width: '30%',
            },
            {
              text: '값',
              width: '70%',
            },
          ],
          selectedItem: {
            codeSysUri: {
              name: '용어체계',
              value: '',
              isCustom: true,
            },
            mesureKey: {
              name: 'Mesure Key',
              value: '',
            },
            mesureCodeNm: {
              name: '코드 이름',
              value: '',
            },
            mesureCodeDc: {
              name: '코드 설명',
              value: '',
            },
            resourceTypeCodeNm: {
              name: '리소스 타입',
              value: '',
            },
            mesureCode: {
              name: '코드 값',
              value: '',
            },
            children: {
              name: '하위 코드',
              value: [],
              isCustom: true,
            },
            crtrId: {
              name: '등록자',
              value: '',
            },
            creatDt: {
              name: '등록일자',
              value: '',
            },
            updusrId: {
              name: '수정자',
              value: '',
            },
            updtDt: {
              name: '수정일자',
              value: '',
            },
          },
        },
      ];
    },
    btnUpdate() {
      return this.$i18n.t('common.btn.update');
    },
    btnDelete() {
      return this.$i18n.t('common.btn.delete');
    },
    showTemplateBtn() {
      return (
        process.env.VUE_APP_NODE == 'ADV' || process.env.VUE_APP_NODE == 'LOCAL'
      );
    },
  },
  created() {
    this.tabItems = this.tabItemsComputed;
    this.initCommonCode(this.phrCodeSysTys, this.fhirResrceTys);
  },
};
</script>

<style scoped lang="scss">
@charset "UTF-8";
.phr_code_children_tab {
  overflow: auto;
}

.phr_code_children_tab table {
  border-top: 1px solid #ccc;
}

.phr_code_children_tab thead th {
  background: #f6f6f6 !important;
  text-align: left;
}

::v-deep {
  .panel-top-sort {
    min-height: 70px !important;
  }
}

.bt-line24 {
  margin: 1.5px;
}
</style>
